module.exports = __webpack_public_path__ + "static/media/Icon_feather-filter.97ee8c17.svg";